module.exports = __webpack_public_path__ + "img/head-img-female.b485bc26.png";